<template>
  <Block :title="t('title')" emoji="✅">
    <template #subtitle>
      <p class="text-sm text-gray-600">
        {{ t("region_rate_label") }}
        <span class="font-bold" :class="rateColorClass">{{ formattedRegionRate }}</span>
      </p>
    </template>

    <template v-if="storesBelowThreshold.length > 0">
      <p class="px-6 pb-1 text-xs font-bold text-gray-500 uppercase">{{ t("stores_below_label") }}</p>
      <BlockList :items="storesBelowThreshold" key-field="name">
        <template #default="{ item: store }">
          <span>{{ store.name }}</span>
          <span class="font-bold text-red-600 whitespace-nowrap">{{ formatPercentage(store.rate) }}</span>
        </template>
      </BlockList>
    </template>
    <div v-else-if="multiStore" class="px-6 pb-3 text-xs text-green-600 font-bold">
      {{ t("all_compliant") }}
    </div>

    <div class="mx-6 mb-4 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2 text-xs text-yellow-800">
      {{ t("reminder") }}
    </div>
  </Block>
</template>

<script>
import { Block, BlockList, formatPercentage } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  components: {
    Block,
    BlockList,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    compliance: {
      type: Object,
      required: true,
    },
    multiStore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    regionRate() {
      return this.compliance.regionRate ?? 0;
    },
    formattedRegionRate() {
      return formatPercentage(this.regionRate);
    },
    rateColorClass() {
      const pct = this.regionRate * 100;
      if (pct >= 90) return "text-green-600";
      if (pct >= 70) return "text-yellow-600";
      return "text-red-600";
    },
    storesBelowThreshold() {
      return this.compliance.storesBelowThreshold || [];
    },
  },
  methods: {
    formatPercentage,
  },
};
</script>

<i18n src="./ComplianceBlock.i18n.json"></i18n>
